export type ChartType = 'bar' | 'line' | 'pie' | 'stacked-bar' | 'multiple-bar' | 'multiple-line';

// Helper function to map frontend chart types to backend enum
export function mapChartTypeToBackend(frontendType: string): ChartType | null {
  const mapping: Record<string, ChartType> = {
    'bar': 'bar',
    'line': 'line',
    'pie': 'pie',
    'stacked-bar': 'stacked-bar',
    'multiple-stacked-bar': 'multiple-bar',
    'multiple-clustered-bar': 'multiple-bar',
    'multiple-bar': 'multiple-bar',
    'multiple-line': 'multiple-line',
  };

  return mapping[frontendType] || null;
}